import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { countReportingVentureStatuses, isReportingRequestComplete } from '~/functions/reporting';
import { renderSafeMarkdown } from '~/functions/markdown';
import { ReportingRequestType, useGetReportingRequestQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var route = useRoute();
    var router = useRouter();
    var requestId = computed(function () {
      return route.params.requestId;
    });
    var _useGetReportingReque = useGetReportingRequestQuery(computed(function () {
        return {
          id: requestId.value
        };
      }), computed(function () {
        return {
          enabled: !!requestId.value,
          fetchPolicy: 'cache-and-network'
        };
      })),
      result = _useGetReportingReque.result,
      loading = _useGetReportingReque.loading,
      refetch = _useGetReportingReque.refetch;
    onActivated(function () {
      if (requestId.value) {
        refetch();
      }
    });
    var request = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getReportingRequest;
    });
    var isEsgRequest = computed(function () {
      var _request$value;
      return ((_request$value = request.value) === null || _request$value === void 0 ? void 0 : _request$value.requestType) === ReportingRequestType.Esg;
    });
    var renderedDescription = computed(function () {
      var _request$value2;
      return (_request$value2 = request.value) !== null && _request$value2 !== void 0 && _request$value2.description ? renderSafeMarkdown(request.value.description) : '';
    });
    var ventureStatusCounts = computed(function () {
      var _request$value3;
      return countReportingVentureStatuses((_request$value3 = request.value) === null || _request$value3 === void 0 ? void 0 : _request$value3.ventures);
    });
    var isRequestComplete = computed(function () {
      var _request$value4;
      return isReportingRequestComplete((_request$value4 = request.value) === null || _request$value4 === void 0 ? void 0 : _request$value4.ventures);
    });
    var requestTypeText = function requestTypeText(requestType) {
      switch (requestType) {
        case ReportingRequestType.ImpactCarry:
          return String(proxy.$t('typeImpactCarry'));
        case ReportingRequestType.Esg:
          return String(proxy.$t('typeEsg'));
        default:
          return String(proxy.$t('typeKpi'));
      }
    };
    var statusSortOrder = {
      NOT_STARTED: 0,
      IN_PROGRESS: 1,
      COMPLETE: 2
    };
    var sortedVentures = computed(function () {
      var _request$value$ventur, _request$value5;
      return _toConsumableArray((_request$value$ventur = (_request$value5 = request.value) === null || _request$value5 === void 0 ? void 0 : _request$value5.ventures) !== null && _request$value$ventur !== void 0 ? _request$value$ventur : []).sort(function (a, b) {
        var _statusSortOrder, _statusSortOrder2, _a$venture$name, _a$venture, _b$venture$name, _b$venture;
        var aOrder = (_statusSortOrder = statusSortOrder[a.status || 'NOT_STARTED']) !== null && _statusSortOrder !== void 0 ? _statusSortOrder : 0;
        var bOrder = (_statusSortOrder2 = statusSortOrder[b.status || 'NOT_STARTED']) !== null && _statusSortOrder2 !== void 0 ? _statusSortOrder2 : 0;
        if (aOrder !== bOrder) {
          return aOrder - bOrder;
        }
        return ((_a$venture$name = (_a$venture = a.venture) === null || _a$venture === void 0 ? void 0 : _a$venture.name) !== null && _a$venture$name !== void 0 ? _a$venture$name : '').localeCompare((_b$venture$name = (_b$venture = b.venture) === null || _b$venture === void 0 ? void 0 : _b$venture.name) !== null && _b$venture$name !== void 0 ? _b$venture$name : '');
      });
    });
    watch(loading, function (isLoading) {
      if (!isLoading && !request.value && requestId.value) {
        router.replace({
          name: 'portfolio-requests'
        });
      }
    });
    var companyHeaders = computed(function () {
      var headers = [{
        text: '',
        value: 'logo',
        sortable: false,
        class: 'review-table-th',
        width: '48px'
      }, {
        text: proxy.$t('company'),
        value: 'venture.name',
        class: 'review-table-th'
      }, {
        text: proxy.$t('status'),
        value: 'status',
        class: 'review-table-th',
        width: '140px'
      }];
      if (isEsgRequest.value) {
        headers.push({
          text: proxy.$t('questionnaire'),
          value: 'questionnaire',
          class: 'review-table-th',
          sortable: false,
          width: '140px'
        });
      } else {
        headers.push({
          text: proxy.$t('progress'),
          value: 'progress',
          class: 'review-table-th',
          sortable: false,
          width: '280px'
        });
      }
      headers.push({
        text: '',
        value: 'actions',
        sortable: false,
        align: 'end',
        class: 'review-table-th',
        width: '56px'
      });
      return headers;
    });
    var companyRequestPath = function companyRequestPath(ventureId) {
      return "/".concat(ventureId, "/reporting-request/").concat(requestId.value);
    };
    var companyInitial = function companyInitial(name) {
      var trimmed = (name || '').trim();
      return trimmed ? trimmed.charAt(0).toUpperCase() : '?';
    };
    var goToCompany = function goToCompany(_e, _ref2) {
      var item = _ref2.item;
      router.push(companyRequestPath(item.ventureId));
    };
    var goToCompanyRow = function goToCompanyRow(item) {
      router.push(companyRequestPath(item.ventureId));
    };
    var formatDate = function formatDate(value) {
      if (!value) {
        return '—';
      }
      return new Date(value).toLocaleString();
    };
    var formatDueDate = function formatDueDate(value) {
      if (!value) {
        return '—';
      }
      return new Date(value).toLocaleDateString();
    };
    return {
      __sfc: true,
      proxy: proxy,
      route: route,
      router: router,
      requestId: requestId,
      result: result,
      loading: loading,
      refetch: refetch,
      request: request,
      isEsgRequest: isEsgRequest,
      renderedDescription: renderedDescription,
      ventureStatusCounts: ventureStatusCounts,
      isRequestComplete: isRequestComplete,
      requestTypeText: requestTypeText,
      statusSortOrder: statusSortOrder,
      sortedVentures: sortedVentures,
      companyHeaders: companyHeaders,
      companyRequestPath: companyRequestPath,
      companyInitial: companyInitial,
      goToCompany: goToCompany,
      goToCompanyRow: goToCompanyRow,
      formatDate: formatDate,
      formatDueDate: formatDueDate
    };
  }
});